import React, { ChangeEvent } from 'react';
import { useLanguage } from "../context/LanguageContext";

interface BinaryQuestionProps {
  question: React.ReactNode; 
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function BinaryQuestion({ question, name, value, onChange }: BinaryQuestionProps) {

  const { t } = useLanguage();

    return (
      <fieldset>
        <legend className="text-gray-800 text-lg font-light">{question}</legend>
          <div className="mx-auto w-fit flex space-x-10 mt-4">
            <label className="text-gray-900 text-lg">
              <input
                className="mx-2"
                name={name}
                type="radio"
                value="1"
                checked={value === "1"}
                onChange={onChange}
                aria-checked={value === "1"}
              />
              {t.secondForm.sim}
            </label>
            <label className="mx-2 text-gray-800 text-lg">
              <input
                className="mx-2"
                name={name}
                type="radio"
                value="0"
                checked={value === "0"}
                onChange={onChange}
                aria-checked={value === "0"}
                />
              {t.secondForm.nao}
            </label>
          </div>
      </fieldset>
    );
}

export default BinaryQuestion;